import React, {Fragment, PureComponent} from 'react';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import UploadCvForm from '../../../components/Forms/UploadCvForm/UploadCvForm.jsx';
import {CREATE_FREELANCE_STEPS, updateCreatFreelanceStep} from "../../../../shared/containers/Freelance/setNextStep.js";

export default class CVStep extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
  };

  setCvUploaded =  () => {

    const {agent, ...freelanceData} = this.props.freelance
    const nextStep = CREATE_FREELANCE_STEPS.ADDITIONAL_INFO

    updateCreatFreelanceStep(
      freelanceData.id,
      nextStep,
      () => this.props.submit({
        freelance: {
          ...freelanceData
        },
        silentMode: true,
      })
    )
  };

  onUploadSuccess = async (cv) => {
    console.info({cv})
    return
  };

  render() {
    const {freelance} = this.props;

    return (
      <Fragment>
        <h2 className="text-center">Curriculum</h2>

        <p className="text-center mb-4">
          Vous pouvez nous transmettre un CV, même si celui-ci ne recense pas votre dernière activité ou que quelques
          informations manquent à l'appel. Cela nous permettra d'échanger sur votre parcours lors de notre rencontre
          en visio.
        </p>
        <UploadCvForm
          className="upload-container mb-4"
          onSubmitSuccess={this.setCvUploaded}
          onUploadSuccess={this.onUploadSuccess}
          freelanceId={freelance?.id ?? 0}
        />
        <div className="text-right">
          <Button color="primary" onClick={this.setCvUploaded}>Déposer mon CV plus tard</Button>
        </div>
      </Fragment>)
  }
}
